import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure.svg';
import classname from 'classnames';
import PropTypes from 'prop-types';
import { deepFilter, deepFind } from 'react-children-utilities';

const Header = () => null
const Icon = () => null
const Subheader = () => null
const Body = () => null
const Footer = () => null
const Close = () => null
const FooterLeft = () => null
const FooterRight = () => null
const Subtitle = () => null
const Title = () => null

const First = () => null
const Second = () => null
const Third = () => null

const Col = () => null

const CardConfigure = ({ children, type, addHeaderClass, ...rest }) => {

	const header = deepFind(children, child => child.type === Header)
	const icon = deepFind(children, child => child.type === Icon)
	const subheader = deepFind(children, child => child.type === Subheader)
	const body = deepFind(children, child => child.type === Body)
	const footer = deepFind(children, child => child.type === Footer)
	const close = deepFind(children, child => child.type === Close)
	const footerLeft = deepFind(children, child => child.type === FooterLeft)
	const footerRight = deepFind(children, child => child.type === FooterRight)
	const subtitle = deepFind(children, child => child.type === Subtitle)
	const title = deepFind(children, child => child.type === Title)

	const first = deepFind(children, child => child.type === First)
	const second = deepFind(children, child => child.type === Second)
	const third = deepFind(children, child => child.type === Third)

	const cols = deepFilter(body?.props.children, child => {
		return child
	})

	const iconClass = classname({
		'card-configure__rounded-square': icon?.props?.round === true,
		'card-configure__icon': icon?.props.type === 'false' ? false : true,
		'card-configure__icon--error': icon?.props.type === 'error' ? true : false
	})

	const headerClass = classname(
		addHeaderClass,
		{
			"card-configure-data__dictionary__header": type === "data-dictionary",
			"card-configure__header": type !== "data-dictionary"
		}
	)

	return (
		<div className="card-configure" {...rest}>

			{header && (
				<div className={headerClass}>
					<div className="card-configure__header__left">
						<div className="card-configure__title">
							<div className="card-configure__title__left">
								{icon?.props?.type !== 'none' &&
									<div className={iconClass}>
										{icon ? icon.props.children : <IconConfigure />}
									</div>
								}
							</div>
							<div className="card-configure__title__right">
								<div className="card-configure__title__right__top">
									{title && title.props.children}
								</div>
								<div className="card-configure__title__right__bottom">
									{subtitle && subtitle.props.children}
								</div>
							</div>
						</div>
					</div>
					<div className="card-configure__header__right">
						{close &&
							<div className="card-configure__close" {...close.props}>
								{close.props.children}
							</div>
						}
					</div>
				</div>
			)}

			{subheader && (
				<div className="card-configure__sub-header">
					{subheader && subheader.props.children}
				</div>
			)}

			{body && (
				<div className="card-configure__content">
					<div className="card-configure__content__cols">
						{cols && cols.map((col, index) => {
							return (
								<div className={type === "data-dictionary" ? "card-configure__content__data-col" : "card-configure__content__col"} key={index}>{col.props.children}</div>
							)
						})}
					</div>
				</div>
			)}

			{footer && (
				<div className="card-configure__footer">
					<div className="card-configure__footer__left">
						{footerLeft && footerLeft.props.children}
					</div>
					<div className="card-configure__footer__right">
						{footerRight && footerRight.props.children}
					</div>
				</div>
			)}


		</div>
	)
}

CardConfigure.Header = Header
CardConfigure.Header.Icon = Icon
CardConfigure.Header.Title = Title
CardConfigure.Header.Subtitle = Subtitle
CardConfigure.Header.Close = Close
CardConfigure.Subheader = Subheader
CardConfigure.Body = Body
CardConfigure.Body.First = First
CardConfigure.Body.Second = Second
CardConfigure.Body.Third = Third
CardConfigure.Footer = Footer
CardConfigure.Footer.Left = FooterLeft
CardConfigure.Footer.Right = FooterRight
CardConfigure.Body.Col = Col

CardConfigure.propTypes = {
	type: PropTypes.string,
	addHeaderClass: PropTypes.string,
	children: PropTypes.node
}

export default CardConfigure
